import Sidebar from '../components/Sidebar';

export default function AutoTest() {
    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container">
                <h1>AutoTest</h1>
            </div>
        </div>
    ); 
}